import TendersView from './Tenders';

export default TendersView;
